<div class="loading-panel" [hidden]="hideLoader">
    <div class="loading-panel-mask"></div>
    <div class="loading-panel-wrapper">
      <kendo-loader type="infinite-spinner" size="medium"></kendo-loader> 
      <div class="loading-panel-text">Loading...</div>
    </div>
  </div>